// extracted by mini-css-extract-plugin
export default {"aboutWrapper":"About_aboutWrapper__lOR5m","aboutWrapper__info":"About_aboutWrapper__info__mrWqz","aboutWrapper__image":"About_aboutWrapper__image__u7OQW","up":"About_up__MgXef"};